import { Pipe, PipeTransform } from '@angular/core';
import { Nillable } from '@web/utils';

@Pipe({
  name: 'trueOrFalse',
  standalone: true,
})
export class TrueOrFalsePipe implements PipeTransform {
  public transform<T>(predictable: Nillable<T>): boolean {
    return !!predictable;
  }
}
